import { useEffect, useState } from "react";
import { History, Trash2 } from "lucide-react";
import { getToolHistory, clearToolHistory } from "../../lib/toolHistory";
import { useToolsT } from "../../lib/toolsI18n";

export function SavedNumbers({ slug }) {
  const { tt } = useToolsT();
  const [list, setList] = useState(() => getToolHistory(slug));

  useEffect(() => {
    const refresh = (e) => {
      if (!e.detail || e.detail.slug === slug) setList(getToolHistory(slug));
    };
    window.addEventListener("amd-tool-saved", refresh);
    return () => window.removeEventListener("amd-tool-saved", refresh);
  }, [slug]);

  if (!list.length) return null;

  const fmt = (ts) =>
    new Date(ts).toLocaleString(undefined, {
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
    });

  return (
    <div className="mt-5 rounded-2xl border-2 border-slate-200 bg-slate-50/60 p-5" data-testid={`saved-numbers-${slug}`}>
      <div className="flex items-start justify-between gap-3 mb-1">
        <h2 className="font-heading font-bold text-lg text-slate-900 flex items-center gap-2">
          <History className="w-5 h-5 text-teal-600" /> {tt("savedTitle")}
        </h2>
        <button
          onClick={() => clearToolHistory(slug)}
          data-testid="saved-clear"
          className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-500 hover:text-red-600 transition-colors"
        >
          <Trash2 className="w-4 h-4" /> {tt("savedClear")}
        </button>
      </div>
      <p className="text-sm text-slate-500 mb-3">{tt("savedDesc")}</p>
      <ul className="space-y-2">
        {list.map((e) => (
          <li key={e.ts} className="flex items-start gap-3 bg-white border border-slate-200 rounded-xl px-3.5 py-2.5" data-testid="saved-entry">
            <span className="text-xs font-semibold text-slate-400 whitespace-nowrap mt-0.5 w-24 shrink-0">{fmt(e.ts)}</span>
            <span className="text-sm text-slate-800 font-medium">{e.value}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
